// Vendored from cube-js/cube@d403e7a0 packages/cubejs-api-gateway/src/user-error.ts, Apache-2.0 (Copyright Cube Dev, Inc.).
// Changed: extends Error, since Cube's CubejsHandlerError carries HTTP fields this code has no use for.

export class UserError extends Error {}
